import { getInstance } from "./index";
import store from "../store"
import { baseGuard } from "./baseGuard";

/*
    Sjekke om bruker har verifisert sin e-post og så om bruker er lagt til i våres database,
    hvis ikke så blir bruker sendt ditt der han/hun hører til.
*/
export const profileGuard = (to, from, next) => {
  const authService = getInstance();

  async function fn() {
    baseGuard(to, from, next);

    // Hvis bruker har data i store, gå rett til profilen uten å gjøre et API-kall.
    if (
      store.state.userInfo !== null
      && store.state.userInfo.auth0Id !== undefined
    ) {
      return next();
    }

    await store.dispatch('getUserInfo', authService.user.sub)
      .then(response => {
        if (!response) return next("/profil/registrer");
        return next();
        // return next(`/profil/${store.state.userInfo.id}`);
      })
      .catch((error) => {
        console.error("Kunne ikke hente Candidate fra API: ", error);
        return next({ name: 'Home' });
      });
  }

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};